import { PATH } from 'constants/path';
import { EInvitedOnboardingStep, InvitedOnboardingStepConfig } from './types';

export const INVITED_ONBOARDING_STEPS: InvitedOnboardingStepConfig[] = [
    { key: EInvitedOnboardingStep.CREATE_PROFILE, title: 'Create profile', order: 1 },
    { key: EInvitedOnboardingStep.SETUP_SERVICES, title: 'Set up services', order: 2 },
    { key: EInvitedOnboardingStep.MARKETING_PROFILE, title: 'List on Klarity Health', order: 3 },
    { key: EInvitedOnboardingStep.AVAILABILITY, title: 'Configure availability', order: 4 },
];

export const INVITED_ONBOARDING_STEP_PATH: Record<EInvitedOnboardingStep, string> = {
    [EInvitedOnboardingStep.ACTIVATE]: PATH.INVITED_PROVIDER_ONBOARDING_ACTIVATE,
    [EInvitedOnboardingStep.CREATE_PROFILE]: PATH.INVITED_PROVIDER_ONBOARDING_CREATE_PROFILE,
    [EInvitedOnboardingStep.SETUP_SERVICES]: PATH.INVITED_PROVIDER_ONBOARDING_SERVICES,
    [EInvitedOnboardingStep.AVAILABILITY]: PATH.INVITED_PROVIDER_ONBOARDING_AVAILABILITY,
    [EInvitedOnboardingStep.MARKETING_PROFILE]: PATH.INVITED_PROVIDER_ONBOARDING_MARKETING_PROFILE,
};
